import { createContext, useContext, useState } from 'react'

const ActiveModuleColorContext = createContext<{
  color: string
  setColor: (c: string) => void
  previewMode: boolean
  setPreviewMode: (v: boolean) => void
}>({ color: '#2563EB', setColor: () => {}, previewMode: false, setPreviewMode: () => {} })

export function ActiveModuleColorProvider({ children }: { children: React.ReactNode }) {
  const [color, setColor] = useState('#2563EB')
  const [previewMode, setPreviewMode] = useState(false)
  return (
    <ActiveModuleColorContext.Provider value={{ color, setColor, previewMode, setPreviewMode }}>
      {children}
    </ActiveModuleColorContext.Provider>
  )
}

export const useActiveModuleColor = () => useContext(ActiveModuleColorContext)
